enum StatusState {
    Sent = 'SENT',
    Received = 'RECEIVED',
    Assigned = 'ASSIGNED',
    Success = 'SUCCESS',
    Failed = 'FAILED',
}

export default StatusState
